import { UI } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React from 'react';

export interface IndicatorIconProps {
  percentage: number;
}

export const IndicatorIcon: React.FC<IndicatorIconProps> = ({ percentage }) => {
  if (typeof percentage !== 'number') {
    return null;
  }

  if (percentage === 0) {
    return <UI.Icon name="Minus" color={Color['neutral.medium']} size="xxxs" />;
  }

  const isPositive = percentage > 0;

  return (
    <UI.Icon
      name={isPositive ? 'ArrowUp' : 'ArrowDown'}
      color={isPositive ? Color['feedback.success.default'] : Color['feedback.error.default']}
      size="xxxs"
    />
  );
};
